export default __webpack_public_path__ + "static/pic02-cef9b65fbf89c8b0a0216b68a8afcd7f.jpg";